import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const SERVICE_OPTIONS = [
  { value: "EMDR", label: "EMDR — Trauma reprocessing" },
  { value: "TF-CBT", label: "TF-CBT — Trauma-Focused CBT" },
  { value: "CBT", label: "CBT — Cognitive Behavioral Therapy" },
  { value: "DBT", label: "DBT — Dialectical Behavior Therapy" },
  { value: "MST", label: "MST — Multi-Systemic Therapy" },
  { value: "Consultation", label: "Free 15-min Consultation" },
];

export const SESSION_LENGTHS = [
  { value: "60", label: "60 minutes — $150" },
  { value: "90", label: "90 minutes — $200 (recommended for EMDR)" },
];

export const AGE_RANGES = [
  { value: "10-17", label: "Adolescent (10–17)" },
  { value: "18-30", label: "Young Adult (18–30)" },
  { value: "31-50", label: "Adult (31–50)" },
];

export const CONCERN_OPTIONS = ["PTSD", "Depression", "Anxiety", "Other"];

export function formatTime(t) {
  const [hStr, m] = t.split(":");
  const h = parseInt(hStr, 10);
  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${m} ${suffix}`;
}

export function formatDate(dateStr) {
  // Treat as local date to avoid TZ shift
  const [y, mo, d] = dateStr.split("-").map(Number);
  const dt = new Date(y, mo - 1, d);
  return dt.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function toISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
